import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import classNames from 'classnames';
import React, { useRef, useEffect } from 'react';
import debounce from '../../utils/debounce.esm.js';

var _excluded = ["className", "onChange"];
var styles = {
  width: 99,
  height: 99,
  position: 'absolute',
  top: -9999,
  overflow: 'scroll'
};
var ScrollbarSizeListener = function ScrollbarSizeListener(props) {
  var className = props.className,
    onChange = props.onChange,
    other = _objectWithoutProperties(props, _excluded);
  var scrollbarSize = useRef();
  var nodeRef = useRef(null);
  var setMeasurements = function setMeasurements() {
    scrollbarSize.current = nodeRef.current ? {
      height: nodeRef.current.offsetHeight - nodeRef.current.clientHeight,
      width: nodeRef.current.offsetWidth - nodeRef.current.clientWidth
    } : undefined;
  };
  useEffect(function () {
    var handleResize = debounce(function () {
      var prevHeight = scrollbarSize.current;
      setMeasurements();
      if (prevHeight !== scrollbarSize.current) {
        onChange(scrollbarSize.current);
      }
    });
    window.addEventListener('resize', handleResize);
    return function () {
      handleResize.clear();
      window.removeEventListener('resize', handleResize);
    };
  }, [onChange]);
  useEffect(function () {
    setMeasurements();
    onChange(scrollbarSize.current);
  }, [onChange]);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: classNames({
      'csg-tui-scrollbar-size-listener': true
    }, className),
    style: styles,
    ref: nodeRef
  }, other));
};

export default ScrollbarSizeListener;
//# sourceMappingURL=scrollbar-size-listener.esm.js.map
